<template>
  <div class="reportContainer">
    <div v-if="showData" class="titleContainer title-case">
      <span class="workspace-title-text">
        {{ issueType && issueType.length > 0 && issueType[0] && issueType[0].work_space_name ? issueType[0].work_space_name : '' }}
      </span>
      <div class="search-container">
        <span ref="searchContainer" v-if="searchClicked" class="search-input">
          <TextFieldComponent id="search" v-model="searchQuery" @input="searchIssues" flat
            append-inner-icon="mdi-magnify"></TextFieldComponent>
        </span>
        <v-icon v-else @click.stop="toggleSearch" class="search-icon">mdi-magnify</v-icon>
      </div>
    </div>

    <div class="centered-container" v-if="loader">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div class="scrollableContent">
      <div v-if="this.issueType.length == 0 && !loader && !filterData" class="centered-message">
        <strong>Please select the workspace or account</strong>
      </div>
      <div v-if="filterData" class="centered-message">
        <strong>No data found based on your search</strong>
      </div>

      <div
        class="lead-issue-card"
        v-for="(item, index) in issueType"
        :key="index"
        @click="goIssueView(item)"
      >
        <div class="card-avatar-wrap">
          <CustomAvatar2
            class="ma-0 show-cursor"
            :acCode="item.account_code"
            :fName="item.account_name"
            :theme="item.account_theme"
            :imgUrl="item.a_image_url ? item.a_image_url : null"
            :size="'large'"
          />
        </div>

        <div class="card-content-wrap">
          <!-- Row 1: Ref number & Priority icons (Left) + Stage Chip (Right) -->
          <div class="card-header-row">
            <div class="card-ref-wrap">
              <span class="card-ref-text">{{ item.reference_num }}</span>
              <span
                class="card-priority-icons"
                v-if="(item && item.priority == 'high') || item.priority == 'critical' || item.week_end_mails == 'yes'"
              >
                <v-icon v-if="item && item.priority == 'high'" size="14" color="#f59e0b">mdi-exclamation-thick</v-icon>
                <i
                  v-if="item && item.priority == 'critical'"
                  class="pi pi-exclamation-triangle"
                  style="color: #ef4444; font-size: 10px; font-weight: 800"
                />
                <v-icon
                  v-if="item.week_end_mails == 'yes'"
                  size="14"
                  class="mdi mdi-circle-half-full"
                  color="#3b82f6"
                />
              </span>
            </div>

            <div class="card-stage-wrap" v-if="item && item.stage">
              <span class="chip chip-stage">{{ item.stage }}</span>
            </div>
          </div>

          <!-- Row 2: Subject / Name (Full Width, 2-line clamp) -->
          <div class="card-subject-row">
            <div class="issue-name-text" :title="item.name">{{ item.name }}</div>
          </div>

          <!-- Row 3: Meta Chips (Left) + Date/Time (Right) -->
          <div class="card-meta-row">
            <div class="card-chips-group">
              <span class="chip" v-if="item && item.sub_category_name" :title="item.sub_category_name">
                {{ item.sub_category_name }}
              </span>
              <span class="chip2" v-if="item && item.assigned_by_name" :title="item.assigned_by_name">
                {{ item.assigned_by_name }}
              </span>
              <span class="chip3" v-if="item && item.end_date && formatEndDate(item.end_date)">
                {{ formatEndDate(item.end_date) }}
              </span>
            </div>

            <div class="card-datetime-wrap" v-if="getFormattedDate(item)">
              <div class="date-line-main">{{ getFormattedDate(item).date }}</div>
              <div class="date-line-sub">{{ getFormattedDate(item).time }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomAvatar2 from "@/components/ui/CustomAvatar2.vue";
import ProductionDashboardService from "@/api/service/ProductionDashboard/ProductionDashboard";
import TextFieldComponent from "@/components/TextFieldComponent.vue";
import moment from "moment";

export default {
  props: [
    'workspaceId',
    'projectId',
    'accountId',
    'mainFilterData'],
  components: {
    CustomAvatar2,
    TextFieldComponent,
  },

  data() {
    return {
      issueType: [],
      loader: false,
      searchQuery: "",
      searchClicked: false,
      showData: false,
      filterData: false,
      group: "",
      stringValue: "",
    };
  },
  computed: {},
  created() {
    // this.getIssueById();
  },
  watch: {
    workspaceId() {
      this.issueType = [];
      this.loader = true;
      this.showData = true;
      this.getIssueById();
    },
    projectId() {
      this.issueType = [];
      this.loader = true;
      this.showData = true;
      this.getIssueById();
    },
    accountId() {
      this.issueType = [];
      this.loader = true;
      this.showData = true;
      this.getIssueById();
    },
    mainFilterData() {
      // this.getIssueById()
    },
  },
  methods: {
    moment,

    goIssueView(item) {
      let status = this.$store.getters.getMyspace;

      localStorage.setItem(
        "_WS_DEFAULTS_",
        JSON.stringify({
          workspace: { id: item.work_space_id, name: item.work_space_name },
        })
      );
      localStorage.setItem("workSpaceId", item.work_space_id);

      // this.$router.push({ path: "/issueView2", query: { id: item.id } });
      this.$store.dispatch("setIssueInView", item.id);
      let wsDefaults = {
        workspace: { id: item.work_space_id, name: item.work_space_name },
        account: { id: item.account_id, name: item.account_name },
        project: { id: item.project_id, name: item.project_name },
      };
      let wsDefaultsData = JSON.stringify(wsDefaults);
      localStorage.setItem("_WS_DEFAULTS_", wsDefaultsData);
      // console.log(wsDefaultsData,'alert111111111')
      this.$store.commit("SET_REFRESH_BREADCRUMP", true);
      this.$store.commit("CHANGE_MY_SPACE", !status);
    },
    async getIssueById() {
      let obj = this.mainFilterData ? this.mainFilterData : {}
      let $workspaceId = obj && obj.work_space_id ? obj.work_space_id : this.workspaceId
      obj.work_space_id = $workspaceId
      obj.account_id = this.accountId
      obj.project_id = this.projectId

      try {
        let $res = await ProductionDashboardService.liveBoardIssue(obj);

        if ($res && $res.length > 0) {
          this.issueType = $res;
        } else {
          this.issueType = []; // No data, set to an empty array
        }

        this.loader = false; // Set loader to false regardless of whether there's data or not
      } catch (error) {
        console.error("Error fetching data:", error);
        this.issueType = []; // Set to an empty array in case of an error
        this.loader = false; // Set loader to false in case of an error
      }
    },

    async searchIssues() {
      // Ensure you have the original data stored locally
      if (!this.originalIssueType) {
        this.originalIssueType = [...this.issueType];
      }

      // Filter based on the original data
      const filteredIssues = this.originalIssueType.filter((item) =>
        item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
      if (filteredIssues == 0) {
        this.filterData = true;
      } else {
        this.filterData = false;
      }
      // Update the displayed issues
      this.issueType = filteredIssues;
    },

    toggleSearch() {
      this.searchClicked = !this.searchClicked;
      if (this.searchClicked) {
        this.$nextTick(() => {
          this.$refs.searchContainer.querySelector("input").focus();
        });
      }
    },
    handleOutsideClick(event) {
      const textField = this.$refs.searchContainer;
      if (textField && !textField.contains(event.target)) {
        this.searchClicked = false;
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    formatEndDate(date) {
      if (!date) return "";
      const m = moment(date);
      if (!m.isValid() || m.format("MM/DD/YYYY hh:mm A") === "Invalid date") return "";
      return m.format("MM/DD/YYYY");
    },
    getFormattedDate(item) {
      if (!item) return null;
      const raw = item.mail_date || item.created;
      if (!raw) return null;
      const m = moment(raw);
      if (!m.isValid() || m.format("MM/DD/YYYY hh:mm A") === "Invalid date") return null;
      return {
        date: m.format("MM/DD/YYYY"),
        time: m.format("ddd hh:mm A"),
      };
    },
  },
};
</script>

<style scoped>
.reportContainer {
  height: calc(100vh - 130px);
  min-height: 500px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.centered-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
}

.titleContainer {
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  padding: 14px 16px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  box-sizing: border-box;
}

.workspace-title-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1 auto;
}

.search-container {
  display: flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;
}

.search-input {
  width: 180px;
  max-width: 100%;
}

.search-icon {
  cursor: pointer;
  color: #475569;
  transition: color 0.15s ease;
}

.search-icon:hover {
  color: #1e293b;
}

.centered-message {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 600;
  font-size: 15px;
  color: #64748b;
  padding: 60px 20px;
}

.scrollableContent {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4px 12px 16px 12px;
}

.lead-issue-card {
  display: flex;
  gap: 12px;
  cursor: pointer;
  padding: 12px 6px;
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.15s ease;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
}

.lead-issue-card:last-child {
  border-bottom: none;
}

.lead-issue-card:hover {
  background-color: #f8fafc;
}

.card-avatar-wrap {
  flex-shrink: 0;
  padding-top: 2px;
}

.card-content-wrap {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.card-ref-wrap {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  overflow: hidden;
}

.card-ref-text {
  color: #64748b;
  font-size: 11.5px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-priority-icons {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.card-stage-wrap {
  flex-shrink: 0;
  margin-left: auto;
}

.chip-stage {
  white-space: nowrap;
  flex-shrink: 0;
}

.card-subject-row {
  width: 100%;
}

.issue-name-text {
  color: #0f172a;
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.35;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  word-break: break-word;
}

.card-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  margin-top: 3px;
}

.card-chips-group {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  min-width: 0;
  flex: 1 1 auto;
}

.card-datetime-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-left: auto;
  white-space: nowrap;
  text-align: right;
  line-height: 1.25;
}

.date-line-main {
  font-size: 11px;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
}

.date-line-sub {
  font-size: 10px;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}

.chip {
  text-transform: capitalize;
  border: 1px solid #f9c644;
  background: #ffe8ae;
  color: #000;
  font-size: 10.5px;
  font-weight: 500;
  padding: 2px 6px;
  height: fit-content;
  width: fit-content;
  border-radius: 4px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  line-height: 1.3;
}

.chip2 {
  text-transform: capitalize;
  border: 1px solid #e38df2;
  background: #f0d8f4;
  color: #000;
  font-size: 10.5px;
  font-weight: 500;
  padding: 2px 6px;
  height: fit-content;
  width: fit-content;
  border-radius: 4px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  line-height: 1.3;
}

.chip3 {
  text-transform: capitalize;
  border: 1px solid #de1212;
  background: #f79393;
  color: #000;
  font-size: 10.5px;
  font-weight: 500;
  padding: 2px 6px;
  height: fit-content;
  width: fit-content;
  border-radius: 4px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  line-height: 1.3;
}

@media (max-width: 480px) {
  .card-meta-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
  .card-datetime-wrap {
    align-items: flex-start;
    margin-left: 0;
    text-align: left;
  }
}
</style>
